/* Open the installed Shopify chat using its public show() method. */
(() => {
  'use strict';
  const root = document.documentElement;
  if (root.dataset.eliteContactChatReady) return;
  root.dataset.eliteContactChatReady = 'true';

  async function waitForChat() {
    const deadline = Date.now() + 10000;
    while (Date.now() < deadline) {
      const chat = document.querySelector('shopify-chat');
      if (chat && typeof chat.show === 'function') return chat;
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    throw new Error('Chat is unavailable');
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-elite-contact-chat]');
    if (!button || button.disabled) return;
    const status = button.closest('.elite-support-hero')?.querySelector('[data-elite-contact-chat-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      // Keep the user activation when the chat component is already ready.
      const readyChat = document.querySelector('shopify-chat');
      const chat = readyChat && typeof readyChat.show === 'function' ? readyChat : await waitForChat();
      chat.show();
    } catch {
      if (status) {
        status.textContent = 'Live chat is currently unavailable. Please use the message form below.';
        status.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
